var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 441,
    viewBox: "0 0 441 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.459 440.621C98.8591 440.621 0.289062 342.051 0.289062 220.451C0.289062 98.8613 98.8591 0.28125 220.459 0.28125C342.049 0.28125 440.629 98.8512 440.629 220.451C440.629 342.051 342.049 440.621 220.459 440.621Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.81 169.23L221.43 89.5195L102.53 145.82H92.9595H90.1695H84.3195V210.45C79.7595 212.19 76.5195 216.59 76.5195 221.77C76.5195 226.37 79.0795 230.38 82.8595 232.43L76.5195 245.88H100.77L94.4295 232.43C98.2095 230.38 100.77 226.37 100.77 221.77C100.77 216.6 97.5295 212.2 92.9695 210.45V189.2L127.81 205.46V248.94C191.05 199.27 252.95 202 313.98 248.94V204.63L387.81 169.23Z",
    fill: "url(#paint0_linear_490_40)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.209 327.268L220.599 351.378L243.899 327.348C229.779 316.078 211.889 315.998 197.209 327.268Z",
    fill: "url(#paint1_linear_490_40)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8096 157.098L53.0996 169.228L78.8096 181.348V157.098Z",
    fill: "url(#paint2_linear_490_40)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.609 268.061L154.369 283.211C171.989 265.321 195.769 255.111 220.879 255.111C245.719 255.111 269.389 265.101 286.959 282.661L301.539 267.441C279.999 245.891 251.349 234.031 220.879 234.031C190.079 234.041 161.219 246.121 139.609 268.061Z",
    fill: "url(#paint3_linear_490_40)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.74 298L182.14 311.77C193.22 302.99 207.87 296.88 220.82 296.88C233.76 296.88 247.84 303 258.92 311.77L272.72 297.45C258.32 286.04 238 278.25 220.82 278.25C203.63 278.25 183.15 286.58 168.74 298Z",
    fill: "url(#paint4_linear_490_40)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_490_40",
    x1: 234.43,
    y1: 125.797,
    x2: 231.16,
    y2: 226.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_490_40",
    x1: 227.134,
    y1: 125.558,
    x2: 223.864,
    y2: 225.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_490_40",
    x1: 67.7473,
    y1: 120.36,
    x2: 64.4769,
    y2: 220.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_490_40",
    x1: 225.209,
    y1: 125.498,
    x2: 221.939,
    y2: 225.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_490_40",
    x1: 226.342,
    y1: 125.534,
    x2: 223.072,
    y2: 225.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c3292dfb7ed9a2e05e0b84e4f17d6a7.svg";
export { ForwardRef as ReactComponent };